import { Router, Route, Routes, useNavigate, useLocation } from '@solidjs/router';
import { createEffect, onMount } from 'solid-js';
import Field from '../../views/field/Field';

const scrollToHash = (hash) => {
  if (!hash) {
    return;
  }
  const id = hash.replace('#', '');
  const el = document.getElementById(id);
  el?.scrollIntoView({ behavior: 'smooth', block: 'start' });
};

const HashScroller = (props) => {
  const location = useLocation();

  createEffect(() => {
    const hash = location.hash || (typeof window !== 'undefined' ? window.location.hash : '');
    if (!hash) {
      return undefined;
    }
    const frame = window.requestAnimationFrame(() => scrollToHash(hash));
    return () => window.cancelAnimationFrame(frame);
  });

  return props.children;
};

/**
 * @param {{ to: string, hash?: string }} props
 */
const RedirectWithHash = (props) => {
  const navigate = useNavigate();

  onMount(() => {
    navigate(props.to, { replace: true });
    if (props.hash) {
      window.requestAnimationFrame(() => {
        window.location.hash = props.hash;
        scrollToHash(props.hash);
      });
    }
  });

  return null;
};

/**
 * Thin SPA shell: one public field plus legacy path redirects.
 */
const AppShell = () => {
  return (
    <Router>
      <HashScroller>
        <Routes>
          <Route path="/" element={<Field />} />
          <Route path="/home" element={<RedirectWithHash to="/" />} />
          <Route path="/work" element={<RedirectWithHash to="/" hash="work" />} />
          <Route path="/about" element={<RedirectWithHash to="/" hash="contact" />} />
          <Route path="/instagram" element={<RedirectWithHash to="/" />} />
          <Route path="/*all" element={<RedirectWithHash to="/" />} />
        </Routes>
      </HashScroller>
    </Router>
  );
};

export default AppShell;
